
export default class MainMenu {
    
    static get selector() {
        return '.burger';
    }

    constructor(el) {
        this.el = el;
        this.menu = document.querySelector('.header__menu');
        this.items = this.menu.querySelectorAll('.header__menuItem--haveChild');
        this.burger = window.document.querySelector('.burger');
        this.isOpen = false;
        this.setEvents();
    }

    open() {
        if(this.isOpen) return;
        document.documentElement.classList.add('menuOpen');
        this.isOpen = true;
    }

    close() {
        if(!this.isOpen) return;
        document.documentElement.classList.remove('menuOpen');
        this.isOpen = false;
    }

    toggle() {
        if(!this.isOpen) this.open();
        else this.close();
    }

    setEvents() {
        window.addEventListener('resize', this.e_resize.bind(this));
        this.burger.addEventListener('click', this.e_clickBurger.bind(this));
        this.items.forEach(item => {
            item.addEventListener('click',e =>{ this.e__clickItem(e, item); });
        });
    }

    // Events

    e_clickBurger(e) {
        e.preventDefault();
        e.target.blur();
        this.items.forEach(item => {
            item.classList.remove('header__subMenu--active');
            let submenu = item.parentNode.querySelector('.header__subMenu');
            submenu.classList.remove('header__subMenu--active');
        });
        this.toggle();
        this

    }

    e__clickItem(e, item) {
        e.preventDefault();
        let submenu = item.parentNode.querySelector('.header__subMenu');
        submenu.classList.toggle('header__subMenu--active');
    }

    e_resize(e) {
        this.close();
    }


}